export const dollarUSFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
